/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { getYYYMMDD } from "../../app-old/utilities/utils";
import { creditAdjustmentApi } from "../../constants/Presets";

// Action Creator
export const types = {
  FETCH_CURRENT_BILL: "[Aggregate] Fetch Current bill",
  FETCH_CURRENT_BILL_SUCCESS: "[Aggregate] Fetch Current bill success",
  FETCH_CURRENT_BILL_FAILED: "[Aggregate] Fetch Current bill failed",

  FETCH_COMPANY_EVOLUTION_BREAK: "[Aggregate] Fetch Company Evolution Break",
  FETCH_COMPANY_EVOLUTION_BREAK_SUCCESS:
    "[Aggregate] Fetch Company Evolution Break success",
  FETCH_COMPANY_EVOLUTION_BREAK_FAILED:
    "[Aggregate] Fetch Company Evolution Break failed",

  FETCH_COUNT_SUMMARY: "[Aggregate] Fetch Count Summary",
  FETCH_COUNT_SUMMARY_SUCCESS: "[Aggregate] Fetch Count Summary success",
  FETCH_COUNT_SUMMARY_FAILED: "[Aggregate] Fetch Count Summary failed",

  FETCH_COMPANY_PREV_EVOLUTION_BREAK:
    "[Aggregate] Fetch Company prev Evolution Break",
  FETCH_COMPANY_PREV_EVOLUTION_BREAK_SUCCESS:
    "[Aggregate] Fetch Company prev Evolution Break success",
  FETCH_COMPANY_PREV_EVOLUTION_BREAK_FAILED:
    "[Aggregate] Fetch Company prev Evolution Break failed",

  FETCH_TOTAL_BREAK: "[Aggregate] Fetch Total Break",
  FETCH_TOTAL_BREAK_SUCCESS: "[Aggregate] Fetch Total Break success",
  FETCH_TOTAL_BREAK_FAILED: "[Aggregate] Fetch Total Break failed",

  FETCH_ALL_RATES: "[Custom Rates] Fetch All Rates",
  FETCH_ALL_RATES_SUCCESS: "[Custom Rates] Fetch All Rates success",
  FETCH_ALL_RATES_FAILED: "[Custom Rates] Fetch All Rates failed",

  FETCH_ALL_STANDARD_RATES: "[Standard Rates] Fetch All Standard Rates",
  FETCH_ALL_STANDARD_RATES_SUCCESS:
    "[Standard Rates] Fetch All Standard Rates success",
  FETCH_ALL_STANDARD_RATES_FAILED:
    "[Standard Rates] Fetch All Standard Rates failed",

  SET_RATE: "[Custom Rates] Set Rate",
  SET_RATE_SUCCESS: "[Custom Rates] Set Rate Success",
  SET_RATE_FAILED: "[Custom Rates] Set Rate Failed",

  SET_STANDARD_RATE: "[Standard Rates] Set Rate",
  SET_STANDARD_RATE_SUCCESS: "[Standard Rates] Set Rate Success",
  SET_STANDARD_RATE_FAILED: "[Standard Rates] Set Rate Failed",

  UPDATE_CUSTOM_RATE: "[Custom Rates] Update custom Rate",
  UPDATE_CUSTOM_RATE_SUCCESS: "[Custom Rates] Update custom Rate Success",
  UPDATE_CUSTOM_RATE_FAILED: "[Custom Rates] update custom Rate Failed",

  UPDATE_STANDARD_RATE: "[Standard Rates] update standard Rate",
  UPDATE_STANDARD_RATE_SUCCESS: "[Standard Rates] Update standard Rate Success",
  UPDATE_STANDARD_RATE_FAILED: "[Standard Rates] Update Standard Rate Failed",
  FETCH_CREDIT_HISTORY: "[Credit History] Fetch Credit History",
  FETCH_CREDIT_HISTORY_SUCCESS: "[Credit History] Fetch Credit History Success",
  FETCH_CREDIT_HISTORY_FAILED: "[Credit History] Fetch Credit History Failed",

  FETCH_BILLING_HISTORY: "[Billing History] Fetch Billing History",
  FETCH_BILLING_HISTORY_SUCCESS:
    "[Billing History] Fetch Billing History Success",
  FETCH_BILLING_HISTORY_FAILED:
    "[Billing History] Fetch Billing History Failed",

  ADJUST_CREDIT: "[Adjust Credit] Adjust Credit",
  ADJUST_CREDIT_SUCCESS: "[Adjust Credit] Credit Adjustment success",
  ADJUST_CREDIT_FAILED: "[Adjust Credit] Credit Adjustment failed",

  DOWNLOAD_INVOICE: "[Billing Invoice] Billing Invoice",
  DOWNLOAD_INVOICE_SUCCESS: "[Billing Invoice] Billing Invoice success",
  DOWNLOAD_INVOICE_FAILED: "[Billing Invoice] Billing Invoice failed",

  FETCH_STANDARD_RATES_LIST: "[Standard Rates] Fetch Standard Rates List",
  FETCH_STANDARD_RATES_LIST_SUCCESS:
    "[Standard Rates] Fetch Standard Rates List Success",
  FETCH_STANDARD_RATES_LIST_FAILED:
    "[Standard Rates] Fetch Standard Rates List Failed",
  CLEAR_STANDARD_RATES_LIST: "[Standard Rates] Clear Standard Rates List",
  LOAD_MORE_STANDARD_RATES: "[Standard Rates] Load More Standard Rates",
  LOAD_MORE_STANDARD_RATES_SUCCESS:
    "[Standard Rates] Load More Standard Rates success",
  LOAD_MORE_STANDARD_RATES_FAILED:
    "[Standard Rates] Load More Standard Rates failed",
  FETCH_A_STANDARD_RATES: "[Standard Rates] Fetch a Standard Rates",
  FETCH_A_STANDARD_RATES_SUCCESS:
    "[Standard Rates] Fetch a Standard Rates Success",
  FETCH_A_STANDARD_RATES_FAILED:
    "[Standard Rates] Fetch a Standard Rates Failed",
  CLEAR_A_STANDARD_RATES: "[Standard Rates] Clear a Standard Rates",
  DELETE_STANDARD_RATE: "[Standard Rates]Delete Standard Rate",
  DELETE_STANDARD_RATE_SUCCESS: "[Standard Rates] Delete Standard Rate Success",
  DELETE_STANDARD_RATE_FAILED: "[Standard Rates] Delete Standard Rate Failed",

  FETCH_CUSTOM_RATES_LIST: "[Custom Rates] Fetch Custom Rates List",
  FETCH_CUSTOM_RATES_LIST_SUCCESS:
    "[Custom Rates] Fetch Custom Rates List Success",
  FETCH_CUSTOM_RATES_LIST_FAILED:
    "[Custom Rates] Fetch Custom Rates List Failed",
  CLEAR_CUSTOM_RATES_LIST: "[Custom Rates] Clear Custom Rates List",

  LOAD_MORE_CUSTOM_RATES: "[Custom Rates] Load More Custom Rates",
  LOAD_MORE_CUSTOM_RATES_SUCCESS:
    "[Custom Rates] Load More Custom Rates success",
  LOAD_MORE_CUSTOM_RATES_FAILED: "[Custom Rates] Load More Custom Rates failed",
  CREATE_STANDARD_RATE: "[Standard Rates] Create Standard Rate",
  CREATE_STANDARD_RATE_SUCCESS: "[Standard Rates] Create Standard Rate Success",
  CREATE_STANDARD_RATE_FAILED: "[Standard Rates] CReate Standard Rate Failed",
  CLEAR_CREATE_RATE_CARD: "[Standard Rates] Clear Create Rate Card",
  FETCH_A_CUSTOM_RATES: "[Custom Rates] Fetch a Custom Rates",
  FETCH_A_CUSTOM_RATES_SUCCESS: "[Custom Rates] Fetch a Custom Rates Success",
  FETCH_A_CUSTOM_RATES_FAILED: "[Custom Rates] Fetch a Custom Rates Failed",
  CREATE_CUSTOM_RATE: "[Custom Rates] Create Custom Rate",
  CREATE_CUSTOM_RATE_SUCCESS: "[Custom Rates] Create Custom Rate Success",
  CREATE_CUSTOM_RATE_FAILED: "[Custom Rates] Create Custom Rate Failed",
  FETCH_CURRENT_STANDARD_RATE: "[Standard Rates] Fetch Current Standard Rate",
  FETCH_CURRENT_STANDARD_RATE_SUCCESS:
    "[Standard Rates] Fetch Current Standard Rate success",
  FETCH_CURRENT_STANDARD_RATE_FAILED:
    "[Standard Rates] Fetch Current Standard Rate Failed",
  CLEAR_A_CUSTOM_RATE: "[Standard Rates] Clear a Custom Rate",
  DELETE_CUSTOM_RATE: "[Custom Rates]Delete Custom Rate",
  DELETE_CUSTOM_RATE_SUCCESS: "[Custom Rates] Delete Custom Rate Success",
  DELETE_CUSTOM_RATE_FAILED: "[Custom Rates] Delete Custom Rate Failed",
  FETCH_A_CUSTOM_RATE_STATUS: "[Custom Rates] Fetch a Custom Rate Status",
  FETCH_A_CUSTOM_RATE_STATUS_SUCCESS:
    "[Custom Rates] Fetch a Custom Rate Status Success",
  FETCH_A_CUSTOM_RATE_STATUS_FAILED:
    "[Custom Rates] Fetch a Custom Rate Status Failed",
  CLEAR_CURRENT_STANDARD_RATE: "[Standard Rates] Clear Current Standard Rate",
  FETCH_A_STANDARD_RATE_STATUS: "[Standard Rates] Fetch a Standard Rate Status",
  FETCH_A_STANDARD_RATE_STATUS_SUCCESS:
    "[Standard Rates] Fetch a Standard Rate Status Success",
  FETCH_A_STANDARD_RATE_STATUS_FAILED:
    "[Standard Rates] Fetch a Standard Rate Status Failed",
  FETCH_PRICING_STATUS: "[Pricing] Fetch Pricing Status",
  FETCH_PRICING_STATUS_SUCCESS: "[Pricing]  Fetch pricing Status Success",
  FETCH_PRICING_STATUS_FAILED: "[Pricing] Fetch Pricing Status Failed",
  FETCH_MEDIATAILOR_DATA_USAGE: "[Aggregate] Fetch Mediatailor Data Usage",
  FETCH_MEDIATAILOR_DATA_USAGE_SUCCESS:
    "[Aggregate] Fetch Mediatailor Data Usage Success",
  FETCH_MEDIATAILOR_DATA_USAGE_FAILED:
    "[Aggregate] Fetch Mediatailor Data Usage Failed",
  CLEAR_MEDIATAILOR_APP_SESSION: "[Aggregate] Clear Mediatailor App session",
};
//
// ─── CURRENT BILL USAGE ACTIONS ─────────────────────────────────────────────────
//

export const FetchCurrentBill = (companyId, isMonthly, startDate, endDate) => {
  isMonthly = isMonthly || false;
  startDate =
    startDate ||
    getYYYMMDD(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  endDate =
    endDate ||
    getYYYMMDD(
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    );
  return {
    type: types.FETCH_CURRENT_BILL,
    payload: {
      companyId,
      isMonthly,
      startDate,
      endDate,
    },
  };
};
export const FetchCurrentBillSuccess = (currentUsage) => ({
  type: types.FETCH_CURRENT_BILL_SUCCESS,
  payload: currentUsage,
});
export const FetchCurrentBillFailed = (error) => ({
  type: types.FETCH_CURRENT_BILL_FAILED,
  payload: error,
});

//
// ─── EVOLUTION BREAK DOWN ACTIONS ───────────────────────────────────────────────
//

export const FetchCompanyEvolutionBreak = (
  breakDownScale,
  companyId,
  isMonthly,
  startDate,
  endDate,
) => {
  isMonthly = isMonthly || false;
  startDate =
    startDate ||
    getYYYMMDD(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  endDate =
    endDate ||
    getYYYMMDD(
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    );

  return {
    type: types.FETCH_COMPANY_EVOLUTION_BREAK,
    payload: {
      breakDownScale,
      companyId,
      isMonthly,
      startDate,
      endDate,
    },
  };
};
export const FetchCompanyEvolutionBreakSuccess = (currentBreakUsage) => ({
  type: types.FETCH_COMPANY_EVOLUTION_BREAK_SUCCESS,
  payload: currentBreakUsage,
});
export const FetchCompanyEvolutionBreakFailed = (error) => ({
  type: types.FETCH_COMPANY_EVOLUTION_BREAK_FAILED,
  payload: error,
});

//
// ─── COUNT SUMMARY ACTIONS ──────────────────────────────────────────────────────
//

export const FetchCountSummary = (customerCode) => ({
  type: types.FETCH_COUNT_SUMMARY,
  payload: customerCode,
});
export const FetchCountSummarySuccess = (summary) => ({
  type: types.FETCH_COUNT_SUMMARY_SUCCESS,
  payload: summary,
});
export const FetchCountSummaryFailed = (error) => ({
  type: types.FETCH_COUNT_SUMMARY_FAILED,
  payload: error,
});

//
// ─── PREVIOUS EVOLUTION BREAK DOWN ACTIONS ───────────────────────────────────────────────
//

export const FetchCompanyPreviousEvolutionBreak = (
  breakDownScale,
  companyId,
  isMonthly,
) => {
  isMonthly = isMonthly || false;
  return {
    type: types.FETCH_COMPANY_PREV_EVOLUTION_BREAK,
    payload: {
      breakDownScale,
      companyId,
      isMonthly,
    },
  };
};
export const FetchPreviousEvolutionBreakSuccess = (previousBreakUsage) => ({
  type: types.FETCH_COMPANY_PREV_EVOLUTION_BREAK_SUCCESS,
  payload: previousBreakUsage,
});
export const FetchPreviousEvolutionBreakFailed = (error) => ({
  type: types.FETCH_COMPANY_PREV_EVOLUTION_BREAK_FAILED,
  payload: error,
});
//
// ─── PREVIOUS EVOLUTION BREAK DOWN ACTIONS ───────────────────────────────────────────────
//

export const FetchTotalBreak = (startDate, endDate, companyId, isMonthly) => ({
  type: types.FETCH_TOTAL_BREAK,
  payload: {
    startDate,
    endDate,
    companyId,
    isMonthly,
  },
});
export const FetchTotalBreakFailed = (payload) => ({
  type: types.FETCH_TOTAL_BREAK_FAILED,
  payload,
});
export const FetchTotalBreakSuccess = (payload) => ({
  type: types.FETCH_TOTAL_BREAK_SUCCESS,
  payload,
});
//
// ─── FETCH ALL RATES ────────────────────────────────────────────────────────────
//

export const FetchAllRates = (
  customerCode,
  page,
  size,
  order,
  query,
  field,
) => ({
  type: types.FETCH_ALL_RATES,
  payload: {
    customerCode,
    page,
    size,
    order,
    query,
    field,
  },
});
export const FetchAllRatesFailed = (payload) => ({
  type: types.FETCH_ALL_RATES_FAILED,
  payload,
});
export const FetchAllRatesSuccess = (payload) => ({
  type: types.FETCH_ALL_RATES_SUCCESS,
  payload,
});
//
// ─── FETCH ALL STANDARD RATES ────────────────────────────────────────────────────────────
//

export const FetchAllStandardRates = (page, size, order, query, field) => ({
  type: types.FETCH_ALL_STANDARD_RATES,
  payload: {
    page,
    size,
    order,
    query,
    field,
  },
});
export const FetchAllStandardRatesFailed = (payload) => ({
  type: types.FETCH_ALL_STANDARD_RATES_FAILED,
  payload,
});
export const FetchAllStandardRatesSuccess = (payload) => ({
  type: types.FETCH_ALL_STANDARD_RATES_SUCCESS,
  payload,
});

//
// ─── SET CUSTOM RATES ──────────────────────────────────────────────────────────────────
//

export const SetRate = (rate) => ({
  type: types.SET_RATE,
  payload: rate,
});
export const SetRateSuccess = (response) => ({
  type: types.SET_RATE_SUCCESS,
  payload: response,
});
export const SetRateFailed = (error) => ({
  type: types.SET_RATE_FAILED,
  payload: error,
});
//
// ─── SET STANDARD RATES ──────────────────────────────────────────────────────────────────
//

export const SetStandardRate = (rate) => ({
  type: types.SET_STANDARD_RATE,
  payload: rate,
});
export const SetStandardRateSuccess = (response) => ({
  type: types.SET_STANDARD_RATE_SUCCESS,
  payload: response,
});
export const SetStandardRateFailed = (error) => ({
  type: types.SET_STANDARD_RATE_FAILED,
  payload: error,
});

//
// ─── UPDATE CUSTOM RATES ──────────────────────────────────────────────────────────────────
//

export const UpdateCustomRate = (rate) => ({
  type: types.UPDATE_CUSTOM_RATE,
  payload: rate,
});
export const UpdateCustomRateSuccess = (response) => ({
  type: types.UPDATE_CUSTOM_RATE_SUCCESS,
  payload: response,
});
export const UpdateCustomRateFailed = (error) => ({
  type: types.UPDATE_CUSTOM_RATE_FAILED,
  payload: error,
});
//
// ─── UPDATE STANDARD RATES ──────────────────────────────────────────────────────────────────
//

export const UpdateStandardRate = (rate) => ({
  type: types.UPDATE_STANDARD_RATE,
  payload: rate,
});
export const UpdateStandardRateSuccess = (response) => ({
  type: types.UPDATE_STANDARD_RATE_SUCCESS,
  payload: response,
});
export const UpdateStandardRateFailed = (error) => ({
  type: types.UPDATE_STANDARD_RATE_FAILED,
  payload: error,
});

//
// ─── FETCH CREDIT HISTORY ──────────────────────────────────────────────────────────────────
//
export const FetchCreditHistory = (credithistory) => ({
  type: types.FETCH_CREDIT_HISTORY,
  payload: credithistory,
});
export const FetchCreditHistorySuccess = (response) => ({
  type: types.FETCH_CREDIT_HISTORY_SUCCESS,
  payload: response,
});
export const FetchCreditHistoryFailed = (error) => ({
  type: types.FETCH_CREDIT_HISTORY_FAILED,
  payload: error,
});

//
// ─── FETCH BILLING HISTORY ──────────────────────────────────────────────────────────────────
//

export const FetchBillingHistory = (billinghistory) => ({
  type: types.FETCH_BILLING_HISTORY,
  payload: billinghistory,
});
export const FetchBillingHistorySuccess = (response) => ({
  type: types.FETCH_BILLING_HISTORY_SUCCESS,
  payload: response,
});
export const FetchBillingHistoryFailed = (error) => ({
  type: types.FETCH_BILLING_HISTORY_FAILED,
  payload: error,
});

//
// ─── ADJUST CUSTOMER CREDITS ─────────────────────────────────────────────────
//
export const CreditAdjustment = (creditAdjustment) => ({
  type: types.ADJUST_CREDIT,
  payload: creditAdjustment,
});

export const CreditAdjustmentSuccess = (response) => ({
  type: types.ADJUST_CREDIT_SUCCESS,
  payload: response,
});
export const CreditAdjustmentFailed = (error) => ({
  type: types.ADJUST_CREDIT_FAILED,
  payload: error,
});

//
// ─── DOWNLOAD INVOICE ─────────────────────────────────────────────────
//
export const DownloadInvoice = (invoiceId) => ({
  type: types.DOWNLOAD_INVOICE,
  payload: invoiceId,
});

export const DownloadInvoiceSuccess = (response) => ({
  type: types.DOWNLOAD_INVOICE_SUCCESS,
  payload: response,
});
export const DownloadInvoiceFailed = (error) => ({
  type: types.DOWNLOAD_INVOICE_FAILED,
  payload: error,
});

export const FetchStandardRatesList = (page, size, sortBy, sortOrder) => ({
  type: types.FETCH_STANDARD_RATES_LIST,
  payload: {
    page,
    size,
    sortBy,
    sortOrder,
  },
});
export const FetchStandardRatesListSuccess = (list) => ({
  type: types.FETCH_STANDARD_RATES_LIST_SUCCESS,
  payload: list,
});
export const FetchStandardRatesListFailed = (error) => ({
  type: types.FETCH_STANDARD_RATES_LIST_FAILED,
  payload: error,
});
export const ClearStandardRatesList = () => ({
  type: types.CLEAR_STANDARD_RATES_LIST,
});
export const LoadMoreStandardRates = (page, size, sortBy, sortOrder) => ({
  type: types.LOAD_MORE_STANDARD_RATES,
  payload: {
    page,
    size,
    sortBy,
    sortOrder,
  },
});
export const LoadMoreStandardRateSuccess = /* istanbul ignore next */ (
  list,
) => ({
  type: types.LOAD_MORE_STANDARD_RATES_SUCCESS,
  payload: list,
});
export const LoadMoreStandardRateFailed = /* istanbul ignore next */ (
  error,
) => ({
  type: types.LOAD_MORE_STANDARD_RATES_FAILED,
  payload: error,
});
export const FetchAStandardRates = (id) => ({
  type: types.FETCH_A_STANDARD_RATES,
  payload: id,
});
export const FetchAStandardRatesSuccess = (response) => ({
  type: types.FETCH_A_STANDARD_RATES_SUCCESS,
  payload: response,
});
export const FetchAStandardRatesFailed = (error) => ({
  type: types.FETCH_A_STANDARD_RATES_FAILED,
  payload: error,
});
export const ClearAStandardRates = () => ({
  type: types.CLEAR_A_STANDARD_RATES,
});
export const DeleteStandardRate = (id) => ({
  type: types.DELETE_STANDARD_RATE,
  payload: id,
});
export const DeleteStandardRateSuccess = (response) => ({
  type: types.DELETE_STANDARD_RATE_SUCCESS,
  payload: response,
});
export const DeleteStandardRateFailed = (error) => ({
  type: types.DELETE_STANDARD_RATE_FAILED,
  payload: error,
});
export const FetchCustomRatesList = (
  page,
  size,
  sortBy,
  sortOrder,
  companyId,
) => ({
  type: types.FETCH_CUSTOM_RATES_LIST,
  payload: {
    page,
    size,
    sortBy,
    sortOrder,
    companyId,
  },
});
export const FetchCustomRatesListSuccess = (list) => ({
  type: types.FETCH_CUSTOM_RATES_LIST_SUCCESS,
  payload: list,
});
export const FetchCustomRatesListFailed = (error) => ({
  type: types.FETCH_CUSTOM_RATES_LIST_FAILED,
  payload: error,
});
export const ClearCustomRatesList = () => ({
  type: types.CLEAR_CUSTOM_RATES_LIST,
});
export const LoadMoreCustomRates = (
  page,
  size,
  sortBy,
  sortOrder,
  companyId,
) => ({
  type: types.LOAD_MORE_CUSTOM_RATES,
  payload: {
    page,
    size,
    sortBy,
    sortOrder,
    companyId,
  },
});
export const LoadMoreCustomRateSuccess = /* istanbul ignore next */ (list) => ({
  type: types.LOAD_MORE_CUSTOM_RATES_SUCCESS,
  payload: list,
});
export const LoadMoreCustomRateFailed = /* istanbul ignore next */ (error) => ({
  type: types.LOAD_MORE_CUSTOM_RATES_FAILED,
  payload: error,
});
export const CreateStandardRate = (rate) => ({
  type: types.CREATE_STANDARD_RATE,
  payload: rate,
});
export const CreateStandardRateSuccess = (response) => ({
  type: types.CREATE_STANDARD_RATE_SUCCESS,
  payload: response,
});
export const CreateStandardRateFailed = (error) => ({
  type: types.CREATE_STANDARD_RATE_FAILED,
  payload: error,
});
export const ClearCreateRateCard = (error) => ({
  type: types.CLEAR_CREATE_RATE_CARD,
});
export const FetchACustomRates = (id) => ({
  type: types.FETCH_A_CUSTOM_RATES,
  payload: id,
});
export const FetchACustomRatesSuccess = (response) => ({
  type: types.FETCH_A_CUSTOM_RATES_SUCCESS,
  payload: response,
});
export const FetchACustomRatesFailed = (error) => ({
  type: types.FETCH_A_CUSTOM_RATES_FAILED,
  payload: error,
});
export const CreateCustomRate = (rate) => ({
  type: types.CREATE_CUSTOM_RATE,
  payload: rate,
});
export const CreateCustomRateSuccess = (response) => ({
  type: types.CREATE_CUSTOM_RATE_SUCCESS,
  payload: response,
});
export const CreateCustomRateFailed = (error) => ({
  type: types.CREATE_CUSTOM_RATE_FAILED,
  payload: error,
});
export const FetchCurrentStandardRate = () => ({
  type: types.FETCH_CURRENT_STANDARD_RATE,
});
export const FetchCurrentStandardRateSuccess = (response) => ({
  type: types.FETCH_CURRENT_STANDARD_RATE_SUCCESS,
  payload: response,
});
export const FetchCurrentStandardRateFailed = (error) => ({
  type: types.FETCH_CURRENT_STANDARD_RATE_FAILED,
  payload: error,
});
export const ClearACustomRate = () => ({
  type: types.CLEAR_A_CUSTOM_RATE,
});
export const DeleteCustomRate = (id) => ({
  type: types.DELETE_CUSTOM_RATE,
  payload: id,
});
export const DeleteCustoRateSuccess = (response) => ({
  type: types.DELETE_CUSTOM_RATE_SUCCESS,
  payload: response,
});
export const DeleteCustomRateFailed = (error) => ({
  type: types.DELETE_CUSTOM_RATE_FAILED,
  payload: error,
});
export const FetchACustomRateStatus = (value) => ({
  type: types.FETCH_A_CUSTOM_RATE_STATUS,
  payload: value,
});
export const FetchACustomRateStatusSuccess = (response) => ({
  type: types.FETCH_A_CUSTOM_RATE_STATUS_SUCCESS,
  payload: response,
});
export const FetchACustomRateStatusFailed = (error) => ({
  type: types.FETCH_A_CUSTOM_RATE_STATUS_FAILED,
  payload: error,
});
export const ClearCurrentStandardRate = () => ({
  type: types.CLEAR_CURRENT_STANDARD_RATE,
});
export const FetchAStandardRateStatus = (value) => ({
  type: types.FETCH_A_STANDARD_RATE_STATUS,
  payload: value,
});
export const FetchAStandardRateStatusSuccess = (response) => ({
  type: types.FETCH_A_STANDARD_RATE_STATUS_SUCCESS,
  payload: response,
});
export const FetchAStandardRateStatusFailed = (error) => ({
  type: types.FETCH_A_STANDARD_RATE_STATUS_FAILED,
  payload: error,
});
export const FetchPricingStatus = (value) => ({
  type: types.FETCH_PRICING_STATUS,
  payload: value,
});
export const FetchPricingStatusSuccess = (response) => ({
  type: types.FETCH_PRICING_STATUS_SUCCESS,
  payload: response,
});
export const FetchPricingStatusFailed = (error) => ({
  type: types.FETCH_PRICING_STATUS_FAILED,
  payload: error,
});
export const FetchMediatailorDataUsage = (value) => ({
  type: types.FETCH_MEDIATAILOR_DATA_USAGE,
  payload: value,
});
export const FetchMediatailorDataUsageSuccess = (value) => ({
  type: types.FETCH_MEDIATAILOR_DATA_USAGE_SUCCESS,
  payload: value,
});
export const FetchMediatailorDataUsageFailed = (value) => ({
  type: types.FETCH_MEDIATAILOR_DATA_USAGE_FAILED,
  payload: value,
});
export const clearAppSession = () => ({
  type: types.CLEAR_MEDIATAILOR_APP_SESSION,
});
